<template>
    <v-card flat>
        <v-overlay :value="loadingUserData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeUser.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="bal-red"
                v-if="hasPermissionForAction(PermissionsConstants.USER, PermissionsConstants.EDIT)"
                @click="editUser"
            >
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "Profile" | t }}
            </v-tab>
            <v-tab-item>
                <profile-tab />
            </v-tab-item>
            <v-tab
                style="text-transform: none !important;"
                v-if="user.id == activeUser.id || user.role == 'superadmin'"
            >
                {{ "Custom links" | t }}
            </v-tab>
            <v-tab-item>
                <custom-links-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import ProfileTab from "./user-tab-items/profile-tab.vue";
import CustomLinksTab from "./user-tab-items/custom-links-tab";
import Store from "../../store";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "user-view",
    components: { ProfileTab, CustomLinksTab },
    data() {
        return {
            tab: 0,
            tabs: ["Profile", "Custom links"]
        };
    },
    mounted() {
        document.addEventListener("keydown", this.nextTab);
        Store.dispatch("UserStore/getUserData", this.$route.params.userId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    computed: {
        ...mapState("UserStore", ["activeUser", "loadingUserData"]),
        ...mapState(["user"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        closeDrawer() {
            this.$router.push({ name: "user-list" });
        },
        editUser() {
            this.$router.push({
                name: "user-edit",
                params: { userId: this.$route.params.userId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editUser();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        }
    }
};
</script>

<style scoped></style>
